import { render, staticRenderFns } from "./creditParamsForm.vue?vue&type=template&id=045d6a4c&"
import script from "./creditParamsForm.vue?vue&type=script&lang=js&"
export * from "./creditParamsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports